import { render } from "./LeaseDetails.vue?vue&type=template&id=4b03d1d4"
import script from "./LeaseDetails.vue?vue&type=script&lang=js"
export * from "./LeaseDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__